// extracted by mini-css-extract-plugin
export default {"loadingContainer":"App_loadingContainer__HttAr","loadingSpinner":"App_loadingSpinner__mIlB6"};